@if (routerLink(); as routerLink) {
  <app-router-link
    [contents]="true"
    [params]="routerLink.params"
    [route]="routerLink.route">
    <ng-content />
  </app-router-link>
}
